import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=f2d7df5a&scoped=true"
import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"
import style0 from "./TabTitle.vue?vue&type=style&index=0&id=f2d7df5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d7df5a",
  null
  
)

export default component.exports